<template>
  <sl-side-panel v-model="modalVisible" :mask-closable="false" :title="itemTitle">
    <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="100">
      <FormItem label="标题" prop="title">
        <!-- <Select v-model="form.title">
          <Option v-for="item in categoryData" :value="item.value" :key="'c'+item.value">{{ item.label }}</Option>
        </Select> -->
        <Input v-model="form.title" :maxlength="20"></Input>
      </FormItem>
      <FormItem label="内容" prop="content">
        <Input v-model="form.content" :maxlength="500" type="textarea" :rows="4"></Input>
      </FormItem>
      <FormItem label="图片" prop="imageList">
        <sl-upload v-model="form.imageList" :limit="9"></sl-upload>
      </FormItem>
      <FormItem label="备注" prop="remark">
        <Input v-model="form.remark" :maxlength="100"></Input>
      </FormItem>
    </Form>
    <div slot="footer">
      <Button :loading="loading" @click="handleSubmit('form')" type="primary">确定</Button>
    </div>
  </sl-side-panel>
</template>
<script>
import dics from './dics.js'
export default {
  data() {
    return {
      ...dics,
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur,change' }],
        content: [{ required: true, message: '请输入内容', trigger: 'blur,change' }],
        // imageList: [{ required: false, message: '请上传图片', trigger: 'blur,change' }],
        remark: [{ required: false, message: '请输入备注', trigger: 'blur,change' }],
      },
      def: {},
      form: {
        id: null,
        title: null,
        content: null,
        imageList: null,
        remark: null,
      },
      id: null,
      loading: false,
      isCreate: true,
      companies: [],
      cates: [],
      carNo: null,
      bullingRules: [],
      modalVisible: false,
      dateValue: [],
      point: []
    }
  },

  computed: {
    itemTitle() {
      return this.isCreate ? '新增信息' : '编辑信息'
    },
    imeiEditable() {
      return !this.carNo
    }
  },
  created() {
    this.def = { ...this.form }
  },
  mounted() {

  },

  methods: {

    init(id) {
      this.reset()
      this.id = id
      this.isCreate = !id
      this.modalVisible = true

      if (this.id) {
        this.query()
      }
    },

    query() {
      this.$request.informationGet(this.id).then(resp => {
        this.$utils.fill(this.form, resp.data)
      })
    },

    reset() {
      this.dateValue = []
      this.$utils.fill(this.form, this.def)
      setTimeout(() => {
        this.$refs['form'].resetFields()
      }, 20)
    },

    save() {
      let params = { ...this.form }

      if (this.id) {
        params.id = this.id
      } else {
        delete params.id
      }
      this.loading = true
      let promise = this.isCreate ? this.$request.informationInsert : this.$request.informationPut
      promise(params).then(resp => {
        if (resp.code) {
          this.$Message.error({ content: resp.msg })
        } else {
          this.$Message.success('保存成功')
          this.$emit('on-update')
          if (!this.id) {
            this.modalVisible = false
          }
        }
        this.loading = false
      })

    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleClose() {
      this.$emit('on-update')
    },
    daterangeChange(v) {
      console.log('-daterangeChange--', v)
      this.dateValue = v
      this.form.beginDatetime = String(v[0] || '')
      this.c_validateField('beginDatetime')
    },
    markerPoint(point) {
      this.point = point
      this.form.longitude = String(point[0] || '')
      this.c_validateField('longitude')
    },
    c_validateField(field) {
      // 触发验证
      this.$refs['form'].validateField(field, errormsg => {
        console.log('errormsg--', errormsg)
      })
    },
    emitAddress(address) {
      this.form.palce = address
      if (!address) {
        // 清楚操作
        this.form.longitude = ''
      }
    }
  }
}

</script>
